/* global process */
/* eslint-disable no-process-env */
export const isDev = () => process.env.NODE_ENV === "development"

export const getMetaContentByName = (name) => {
  const sel = document.querySelector("meta[name='" + name + "']")
  return sel ? sel.getAttribute("content") : null
}

export const rootUrl = isDev() ? "http://localhost:4000" : getMetaContentByName("root-url")

export const isStaging = () => location.host.includes("staging")
